"use strict";

exports.__esModule = true;
exports.default = map;
var _cb = _interopRequireDefault(require("./_cb.js"));
var _isArrayLike = _interopRequireDefault(require("./_isArrayLike.js"));
var _keys2 = _interopRequireDefault(require("./keys.js"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
// Return the results of applying the iteratee to each element.
function map(obj, iteratee, context) {
  iteratee = (0, _cb.default)(iteratee, context);
  var _keys = !(0, _isArrayLike.default)(obj) && (0, _keys2.default)(obj),
    length = (_keys || obj).length,
    results = Array(length);
  for (var index = 0; index < length; index++) {
    var currentKey = _keys ? _keys[index] : index;
    results[index] = iteratee(obj[currentKey], currentKey, obj);
  }
  return results;
}